export default __webpack_public_path__ + "static/media/bg-imaginarium.e52be45a.png";